import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-basic-label",
  templateUrl: "./basic-label.component.html",
  styleUrls: ["./basic-label.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BasicLabelComponent {
  @Input() public text: string | null = null;
}
